import { EnemyData, EnemyMutatorId } from '../types';
import { getRng } from '../utils/Random';
import { FEATURES } from '../features';

const ELITE_MUTATORS: EnemyMutatorId[] = ['thorned', 'hex_pulse', 'fortress', 'static_field'];

export function assignInitialMutator(enemy: EnemyData): void {
  if (!FEATURES.eliteMutators) {
    enemy.mutators = enemy.mutators ?? [];
    return;
  }

  enemy.mutators = enemy.mutators ?? [];
  if (enemy.mutators.length > 0) return;

  if (enemy.elite) {
    enemy.mutators.push(getRng().pick(ELITE_MUTATORS));
    return;
  }

  if (enemy.boss && enemy.phase && enemy.phase >= 2) {
    enemy.mutators.push(getRng().pick(ELITE_MUTATORS));
  }
}

export function ensureBossMutatorForPhase(enemy: EnemyData): void {
  if (!FEATURES.eliteMutators || !enemy.boss) return;
  enemy.mutators = enemy.mutators ?? [];
  if ((enemy.phase ?? 1) >= 2 && enemy.mutators.length === 0) {
    enemy.mutators.push(getRng().pick(ELITE_MUTATORS));
  }
}

export function hasMutator(enemy: EnemyData, id: EnemyMutatorId): boolean {
  return (enemy.mutators ?? []).includes(id);
}

export function listMutators(enemy: EnemyData): EnemyMutatorId[] {
  return [...(enemy.mutators ?? [])];
}
